import { db } from "@/main";

export default {
    state: {
        config: {
          mud: {
            price: {
              drum: 0,
              m3: 0
            },
            quantity: {
              drum: 0,
              m3: 0
            }
          },
          water: {
            price: {
              drum: 0,
              m3: 0
            },
            quantity: {
              drum: 0,
              m3: 0
            }
          },
          solid: {
            price: {
              drum: 0,
            },
            quantity: {
              drum: 0,
            }
          },
          oil: {
            price: {
              drum: 0,
            },
            quantity: {
              drum: 0,
            }
          },
        },
    },
    mutations: {
        SET_CONFIG(state, config) {
            state.config = config
        },
    },
    actions: {
        getConfig( { state, commit } ) {
            if( !state.config.solid.price.drum ) {
              return new Promise((resolve, reject) => {
                db.collection("config").doc("config").get().then(function(doc) {
                    if (doc.exists) {
                      commit('SET_CONFIG', doc.data())
                      resolve()
                    } else {
                      // doc.data() will be undefined in this case
                      commit('SET_ERROR', { section: 'Config', msg: "No such document!" } );
                      reject()
                    }
                }).catch(function(error) {
                  commit('SET_ERROR', { section: 'Config', function: 'getConfig', msg: error });
                  reject()
                })
              })
            }
        },
        updateConfig( { commit }, config ) {
            return new Promise((resolve, reject) => {
              db.collection("config")
                .doc('config')
                .update(config)
                .then(() => {
                  commit('SET_CONFIG', config)
                  resolve()
                })
                .catch(function(error) {
                  commit('SET_ERROR', { section: 'Config', function: 'updateConfig', msg: error });
                  reject()
                })
            })
        }
    }
}